import { useMemo, useCallback } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';

import { getThreadQuery } from '@ts-core/graphql/forum/queries';
import { updateThreadMutation, increaseThreadViewsMutation } from '@ts-core/graphql/forum/mutations';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';

export default function useThread({
  courseId,
  threadId,

  onThreadUpdated,
}) {
  const { onError } = useMutationCompletionHandler();

  const { data, loading, refetch } = useQuery(getThreadQuery, {
    variables: {
      courseId,
      threadId,
    },
    skip: !courseId || !threadId,
    fetchPolicy: 'cache-and-network',
  });
  const thread = useMemo(() => data?.thread || {}, [data]);

  /**
   * Update Thread
   */
  const [updateThread, { loading: updatingThread }] = useMutation(updateThreadMutation, {
    onError,
    onCompleted: onThreadUpdated,
  });
  const onUpdateThread = useCallback(
    (input) => {
      updateThread({
        variables: {
          courseId,
          threadId,
          input,
        },
      });
    },
    [updateThread, courseId, threadId]
  );

  /**
   * Increase Thread Views
   */
  const [increaseThreadViews] = useMutation(increaseThreadViewsMutation);
  const onIncreaseThreadViews = useCallback(() => {
    increaseThreadViews({
      variables: {
        courseId,
        threadId,
      },
    });
  }, [increaseThreadViews, courseId, threadId]);

  return {
    refetchThread: refetch,
    thread,
    loading,

    onUpdateThread,
    updatingThread,

    onIncreaseThreadViews,
  };
}
